var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("Click on the extra smiling face on the left")]),_c('div',{ref:"leftSide"}),_c('div',{ref:"rightSide"})])
}
var staticRenderFns = []

export { render, staticRenderFns }